import { render, staticRenderFns } from "./FilterCategory.vue?vue&type=template&id=d8f596f8&scoped=true&"
import script from "./FilterCategory.vue?vue&type=script&lang=js&"
export * from "./FilterCategory.vue?vue&type=script&lang=js&"
import style0 from "./FilterCategory.vue?vue&type=style&index=0&id=d8f596f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f596f8",
  null
  
)

export default component.exports